import React from 'react';
import styles from './Container.module.css';

export interface ContainerProps {
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  className?: string;
  as?: 'div' | 'section' | 'article' | 'main' | 'header' | 'footer';
}

/**
 * Container Component
 * Provides consistent max-width and padding
 */
export function Container({
  children,
  size = 'xl',
  className = '',
  as: Component = 'div',
}: ContainerProps) {
  const classNames = [
    styles.container,
    styles[size],
    className,
  ].filter(Boolean).join(' ');

  return <Component className={classNames}>{children}</Component>;
}
